import * as Yup from 'yup';

const transformUrl = (url: string) => {
  try {
    if (!url || url === '') return true;
    new URL(url);
    return true;
  } catch (e) {
    return false;
  }
};
const linkValidator = Yup.string()
  .test('isValidUrl', 'Please enter a valid URL', transformUrl)
  .nullable();

export const badgesValidationSchema = Yup.object().shape({
  spotify: linkValidator,
  stitcher: linkValidator,
  tuneIn: linkValidator,
  pandora: linkValidator,
  iheartradio: linkValidator,
});

export const linksValidationSchema = Yup.object().shape({
  facebook: linkValidator,
  instagram: linkValidator,
  twitter: linkValidator,
  linkedIn: linkValidator,
  youTube: linkValidator,
  patreon: linkValidator,
  soundCloud: linkValidator,
});

export const creatorValidationSchema = Yup.object().shape({
  name: Yup.string().required('Name is required'),
  role: Yup.string(),
  link: linkValidator,
});
